module.exports = __webpack_public_path__ + "static/media/logo.73dea7ed.png";